<template>
  <div class="grid-x page-contents-8 carousel-cont">
    <div class="small-1 medium-2 cell align-center align-middle" style="display: flex; " @click="previous">
      <img tabindex="32" @keypress="previous" class="prevArrow" src="@/assets/img/icons/left-carousel-arrow.png" />
    </div>
    <div class="small-10 medium-8 cell">

      <div class='carousel-view'>
        <transition-group
          name='carousel'
          class='carousel'
          tag="div">
          <div
            v-for="slide in slides"
            class='slide'
            :key="slide.id">
            <span class="carouselLabel"><a :tabindex="slide.tabindex" v-bind:href="slide.link" target="_blank">{{ slide.label }}</a></span>
          </div>
        </transition-group>
      </div>

    </div>
    <div class="small-1 medium-2 cell align-center align-middle" style="display: flex; " @click="next">
      <img tabindex="34" @keypress="next" class="nextArrow" src="@/assets/img/icons/right-carousel-arrow.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'developmentCarouselPreUniversity.vue',
  data() {
    return {
      frameToDisplay: 'uni',
      partnershipText: null,
      image: null,
      slides: [
        {
          label: 'LAW',
          link: 'https://www.rarerecruitment.co.uk/foundations/law/index.html',
          id: 0,
          tabindex: -1,
        },
        {
          label: 'CONSULTING',
          link: 'https://www.rarerecruitment.co.uk/foundations/consulting/index.html',
          id: 1,
          tabindex: -1,
        },
        {
          label: 'LAW',
          link: 'https://www.rarerecruitment.co.uk/foundations/law/index.html',
          id: 2,
          tabindex: 33,
        },
        {
          label: 'CONSULTING',
          link: 'https://www.rarerecruitment.co.uk/foundations/consulting/index.html',
          id: 3,
          tabindex: -1,
        },
        {
          label: 'LAW',
          link: 'https://www.rarerecruitment.co.uk/foundations/law/index.html',
          id: 4,
          tabindex: -1,
        },
        {
          label: 'CONSULTING',
          link: 'https://www.rarerecruitment.co.uk/foundations/consulting/index.html',
          id: 5,
          tabindex: -1,
        },
      ],
    };
  },
  methods: {
    next() {
      const first = this.slides.shift();
      this.slides = this.slides.concat(first);

      // Add a tabindex of 20 to the 3rd tab and add -1 to the 2nd tab.
      // This makes it so only the current highlighted tab is keyboard accessible between the two arrows.
      this.slides[1].tabindex = -1;
      this.slides[2].tabindex = 33;
    },
    previous() {
      const last = this.slides.pop();
      this.slides = [last].concat(this.slides);

      // See comment on line 82.
      this.slides[2].tabindex = 33;
      this.slides[3].tabindex = -1;
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  a {
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
  }

  .carousel-view {
    //border: 2px solid blue;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-bottom: 10px;
  }

  .carousel {
    //border: 2px solid green;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-left: 0;
    padding-left: 460px;
    //overflow: hidden;
  }

  .slide {
    //border: 2px solid red;
    transform: translateZ(0) scale(1.0, 1.0);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    transition: transform 0.3s ease-in-out;
    opacity: 0.5;
    flex: 0 0 29em;
    overflow: hidden;
    padding: 0 20px 0 20px;
  }

  .slide:first-of-type {
    opacity: 0 !important;
  }

  .slide:nth-of-type(3) {
    opacity: 1 !important;
  }


  .slide:nth-of-type(3) span {
    //color: red;
    opacity: 1 !important;
    border-bottom: 5px solid $green-highlight;
  }

  .carouselLabel {
    border-bottom: 6px solid $green-highlight;
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    text-align: center;
  }


  .carousel-controls {
    width: 100%;
    padding: 0;
    margin: 0;
    z-index: 99;
    position: relative;
    display: block;
  }

  .prevArrow {
    cursor: pointer;
    display: inline-flex;
    width: 24px;
    height: 24px;
  }

  .nextArrow {
    cursor: pointer;
    display: inline-flex;
    width: 24px;
    height: 24px;
  }

  p {
    color: #ffffff;
    font-weight: normal;
    font-size: 21px;
    font-style: normal;
    font-stretch: normal;

  }

  @media only screen and (max-width: 640px)  {

    .carousel-cont {
      margin-top: 32px;
    }

    .carousel-view {
      height: 100px;
    }

    .carousel {
      height: 100px;
    }

    .carouselLabel {
      //border-bottom: 6px solid $green-highlight;
      font-size: 28px;
      letter-spacing: 6px;
      padding: 7px 0;
    }


  }

  @media only screen and (min-width: 641px)  {

    .carousel-cont {
      margin-top: 96px;
    }

    .carousel-view {
      height: 140px;
    }

    .carousel {
      height: 140px;
    }

    .foundationsHeader {
      padding-left:50px ;
    }
    .uniHeader {
      padding-right:50px ;
    }

    .carouselLabel {
      //border-bottom: 6px solid $green-highlight;
      font-size: 40px;
      letter-spacing: 6px;
      padding: 14px 0;
    }

  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {

    .carousel {
      text-align: center;
    }
    .slide {
      display: none;
      overflow: visible;
      width: 100%;
      transition: none;
    }

    .slide:nth-of-type(3) {
      display: block !important;
      opacity: 1 !important;
      text-align: center;
      margin: 0 0 0 0;
    }

    .slide:nth-of-type(3) span {
      opacity: 1 !important;
      border-bottom: 5px solid $green-highlight;
      text-align: center;
      margin-right: 40px;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/carousels/developmentCarouselFoundations.vue